module.exports = __webpack_public_path__ + "5794e538395f1a7201653ba513b72f68.svg";